// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/style/font.css
// module id = oZJv
// module chunks = 52